// Imports
import {getUrlParameter, initParentClick, scroll_if_anchor,} from './modules/helpers';
import ToggleNav from "./modules/toggle-nav";
import ScrollToTop from "./modules/scroll-to-top";
import Changelog from "./plugins/changelog.js";
import PricingSection from "./modules/pricing";
import {autoInitToggleText} from "./plugins/toggle-text";
import NewsletterForm from "./modules/newsletter-form";
import {initTrackingEvents} from "./modules/tracking";
import {initDemoForm} from "./plugins/form-demo";

import './plugins/bootstrap';
import './plugins/jquery.actooltip';

// Custom Modules
import './modules/search';

autoInitToggleText();

declare const window: any;

document.addEventListener('DOMContentLoaded', () => {
    const changelogElement = document.querySelector('[data-module=changelog]');
    if (changelogElement) {
        new Changelog(changelogElement);
    }

    const pricingSection = document.querySelector<HTMLElement>('.section-plans');
    if (pricingSection) {
        new PricingSection(pricingSection);
    }

    new ScrollToTop({fromHeight: 600});

    document.querySelectorAll<HTMLFormElement>('form[data-subscribe-newsletter]').forEach(form => {
        new NewsletterForm(form);
    });

    scroll_if_anchor(window.location.hash, {speed: 0});
    initParentClick();
    initTrackingEvents();

    const demoForm = document.querySelector<HTMLFormElement>('#demoForm');
    if (demoForm) {
        initDemoForm(demoForm);
    }

    // set coupon code cookie
    let coupon_code = getUrlParameter('coupon_code');
    if (coupon_code) {
        let date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = "wc_coupon_code=" + coupon_code + "; expires=" + date.toGMTString();
    }
});

jQuery(document).ready(function ($) {


    let lastScrollTop = 0;
    $(window).scroll(function () {
        let st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $('#site-top').removeClass('scrollup');
        } else {
            if (lastScrollTop - st > 6) {
                $('#site-top').addClass('scrollup');
            }
        }
        lastScrollTop = st;
    });

    $('.list-faq').each(function () {
        let max = $(this).data('max');

        let count = $(this).find('li').length;
        if (max) {
            $(this).find('li:gt(' + (max - 1) + ')').hide();
        } else {
            $(this).next('.btn-dynamicmore').remove();
        }

        if (count < max) {
            $(this).find('.btn-dynamicmore').hide();
        }
    });

    $('.list-faqs li').addClass('active').on('click', function () {
        $(this).toggleClass('open');
    });

    document.querySelectorAll('.widget.doc-category .section-term').forEach(el => {
        new ToggleNav(el, el.querySelectorAll('h3'), el.querySelector('.nav'));
    });


    $('.section-faq .btn-dynamicmore').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.section-faq').find('.list-faq li').slideDown(500);
        $(this).hide();
    });

    $('[data-youtubeid]').each(function () {
        let $el = $(this);
        let $preview = $el.find('.embedvideo__preview');
        let $embed = $el.find('.embedvideo__embed');

        $el.append('<span class="btn btn-play"></span>').css('position', 'relative');

        if ($el.hasClass('-opacity')) {
            $preview.find('img').fadeTo(0, 0.6);
        }

        $el.find('.btn-play').click(function () {
            let $button = $(this);
            let src = $embed.find('iframe').attr('src');

            if (null === src.match('\\?')) {
                src += '?';
            } else {
                src += '&'
            }

            $embed.find('iframe').attr('src', src + 'autoplay=1&mute=1&rel=0');
            $button.hide();
            setTimeout(function () {
                $preview.hide();
                $embed.show();
            }, 200);

        });

    });


    $("body").on("click", 'a[href*="#"]', function () {
        // not on homepage
        if ($('body.home').length) {
            return;
        }
        if ($(this).parents('#comments').length) {
            return;
        }
        scroll_if_anchor($(this).attr('href'), {fromtop: 85});

    });

    if (typeof $.fn.colorbox !== 'undefined') {
        $('.postcontent a.lightbox img').wrap('<span class="lb_img_wrapper"></span>');

        // Automatically colorbox image links in Image blocks
        document.querySelectorAll('.wp-block-image a').forEach(link => {
            const pattern = /\.(jpg|png|svg)$/;
            if (pattern.test(link.href)) {
                const title = link.parentElement.querySelector('figcaption')?.innerHTML || false;
                $(link).colorbox({
                    rel: 'page',
                    maxWidth: '90%',
                    maxHeight: '80%',
                    next: '<span class="icon-arrow-right"></span>',
                    previous: '<span class="icon-arrow-left"></span>',
                    close: '<span class="icon-cross"></span>',
                    current: false,
                    title: title
                });
            }
        });

        $('a[rel=lightbox]').colorbox({
            maxWidth: '90%',
            maxHeight: '80%',
            next: '<span class="icon-arrow-right"></span>',
            previous: '<span class="icon-arrow-left"></span>',
            close: '<span class="icon-cross"></span>',
            current: false,
            title: false
        });

        $('a.lightbox').attr('rel', 'lightbox-img').colorbox({
            maxWidth: '90%',
            maxHeight: '80%',
            next: '<span class="icon-arrow-right"></span>',
            previous: '<span class="icon-arrow-left"></span>',
            close: '<span class="icon-cross"></span>',
            current: false,
            title: false,
            titlex: function () {
                let $figure = $(this).parent('figure');
                let title = $(this).find('img').attr('title');

                if ($figure.find('figcaption').length > 0) {
                    title = $figure.find('figcaption:eq(0)').text();
                }
                return title;
            }
        });

        $(document).bind('cbox_complete', function () {
            let $title = $('#cboxTitle');
            if (0 === $title.text().length) {
                $title.hide();
            }
        });
    }

    $('.nav-subnav-dropdown > li > a').on('click', function (e) {
        let $subnav = $(this).next('.sub-menu');
        if ($subnav.length) {
            e.preventDefault();
            $subnav.toggle();
        }
    });

    document.querySelectorAll('.faq-question').forEach((el) => {
        el.querySelectorAll('header').forEach(header => {
            el.addEventListener('click', (e) => {
                if (el.classList.contains('active')) {
                    el.classList.remove('active');
                } else {
                    document.querySelectorAll('.faq-question').forEach(el => el.classList.remove('active'));
                    el.classList.add('active');
                }
            });
        })
    })

    document.querySelectorAll('[href="#pricingModal"]').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            let toggle = document.querySelector<HTMLInputElement>('#pricingModalToggle');
            if (toggle) {
                toggle.checked = true;
            }
        });
    });

    const pricingModal = document.querySelector<HTMLElement>('#pricingModal');
    if (pricingModal) {
        let toggle = document.querySelector<HTMLInputElement>('#pricingModalToggle')!;

        pricingModal.querySelector('.pricing-modal__container')?.addEventListener('mouseup', e => e.stopPropagation());
        pricingModal.addEventListener('mouseup', () => toggle.checked = false);
    }


});

// Custom VAT validation
jQuery(document).ajaxComplete((e, hxr) => {
    let json = hxr.responseJSON;

    if (json && json.hasOwnProperty('result')) {
        if (json.result === 'failure') {
            if (json.hasOwnProperty('messages') && json.messages.indexOf('invalid VAT Number') > 0) {
                jQuery('#woocommerce_eu_vat_number_field').addClass('woocommerce-invalid').removeClass('woocommerce-validated');
            }
        } else {
            jQuery('#woocommerce_eu_vat_number_field').addClass('woocommerce-validated').removeClass('woocommerce-invalid');
        }
    }
});
